import { useState, useEffect } from 'react';
import { X, Sparkles, Rocket } from 'lucide-react';
import { api } from '../services/api';

export default function WhatsNewModal() {
    const [isOpen, setIsOpen] = useState(false);
    const [releaseInfo, setReleaseInfo] = useState<{ version: string; notes: string } | null>(null);

    useEffect(() => {
        checkVersion();
    }, []);

    const checkVersion = async () => {
        try {
            const settings = await api.system.getPublicSettings();
            if (settings?.release_version && settings?.release_notes) {
                const currentVersion = settings.release_version;
                const lastSeenVersion = localStorage.getItem('last_seen_version');

                // If version is new (diiferent from last seen), show modal
                if (currentVersion !== lastSeenVersion) {
                    setReleaseInfo({
                        version: settings.release_version,
                        notes: settings.release_notes
                    });
                    setIsOpen(true);
                }
            }
        } catch (error) {
            console.error("Failed to check for updates", error);
        }
    };

    const handleClose = () => {
        if (releaseInfo) {
            localStorage.setItem('last_seen_version', releaseInfo.version);
        }
        setIsOpen(false);
    };

    if (!isOpen || !releaseInfo) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            {/* Backdrop */}
            <div
                className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity"
                onClick={handleClose}
            />

            {/* Modal */}
            <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-enter">
                {/* Header with flashy gradient */}
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-6 text-white text-center relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 opacity-10">
                        <Rocket size={120} />
                    </div>

                    <div className="relative z-10 flex flex-col items-center">
                        <div className="bg-white/20 p-3 rounded-full mb-3 backdrop-blur">
                            <Sparkles size={32} className="text-yellow-300" />
                        </div>
                        <h2 className="text-2xl font-bold">Nouveautés !</h2>
                        <p className="text-blue-100 font-medium mt-1">Version {releaseInfo.version}</p>
                    </div>

                    <button
                        onClick={handleClose}
                        className="absolute top-4 right-4 text-white/70 hover:text-white transition bg-white/10 hover:bg-white/20 rounded-full p-1"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="p-6">
                    <div className="prose prose-sm prose-blue max-w-none">
                        <div className="whitespace-pre-line text-slate-600 leading-relaxed">
                            {releaseInfo.notes}
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 pt-0">
                    <button
                        onClick={handleClose}
                        className="w-full py-3.5 bg-slate-900 text-white font-bold rounded-xl shadow-lg hover:bg-slate-800 transform transition active:scale-95 flex items-center justify-center gap-2"
                    >
                        C'est compris ! 🚀
                    </button>
                </div>
            </div>
        </div>
    );
}
